import {skills_long, skills_short, levelData } from '../../dmView/constants.js';


function extractAc(jsonData) {
    return jsonData?.definition?.armorClass || 0;
}

export const getSkillDetails = (data) => {
    // if old background (no mod) and new race (no mod) = allow racial mod
    // if old background (no mod) and old race (mod) = allow racial mod

    // if NEW background (mod) and old race (mod) = DONT allow racial mod
    // if NEW background (mod) and NEW race (no mod) = DONT allow racial mod
    // ignore racial skill mods if new background is from a newer source i.e. sourceId is greater then 2
    let ignoreRace = false;
    data?.background?.definition?.sources?.forEach(source => {
        if(source?.sourceId > 2) {
            ignoreRace = true
        }
    })

    let total_lvl = 0;
    let spellCastingInfo = null;
    data["classes"].forEach(classDND => {
        total_lvl += classDND["level"];
        classDND.classFeatures.forEach(feature => {
            // Finds spellcasting information for the class
            if(feature.definition.name === "Spellcasting") {
                let from = null;
                // Finds the subclass name if any
                if(classDND?.subclassDefinition?.id === feature?.definition?.classId) {
                    from = classDND.subclassDefinition.name;
                }
                // Find the string regex "is your spellcasting ability for your"
                const match = feature.definition.description.match(/<p><strong><em>Spellcasting Ability\.<\/em><\/strong>\s*([^<]+?)\s+is your spellcasting ability for your\s+([^<]+?)\s+spells\.<\/p>/i);
                if(match) {
                    spellCastingInfo = {
                        ability: match[1],
                        class: match[2],
                        from: from,
                        spellSaveMod: 0
                    };
                }
            }
        })
    });

    let advantages = {} // advantage or disadvantage
    let proficiencies = {} // prof_bonus and expertise
    let saveModifiers = [0 ,0, 0, 0, 0, 0] // modifiers for saving throws STR, DEX, CON, INT, WIS, CHA
    let initExtraBonus = 0
    let newBaseACMods = []
    let maxDexArmorMod = 2;
    let bonusAc = 0
    let bonusAcWhenArmorEquipped = 0
    let bonusSkillInitMods = []
    let bonusHpPerLevel = 0
    let bonuses = {
        "race": [0, 0, 0, 0, 0, 0],
        "class": [0, 0, 0, 0, 0, 0],
        "background": [0, 0, 0, 0, 0, 0],
        "item": [0, 0, 0, 0, 0, 0],
        "feat": [0, 0, 0, 0, 0, 0],
        "set": [0, 0, 0, 0, 0, 0]
    }

    // Jack of All Trades - TODO
    Object.entries(data.modifiers).forEach(([key, modsArray]) => {

        //1789132
        //This modTypeArray is modifiers - class - race - feat - item - which is the key
        modsArray.forEach(mod => {
            // console.log("Mod Type:", key, "Mod:", mod)
            // Get proficiency even if ignoreRace = true
            // mod["type"] is modifiers.class[0].type - bonus | set | proficiency
            if(mod["type"] === "proficiency" || mod["type"] === "expertise" || mod["type"] === "half-proficiency") {
                // i.e. {"history": "proficiency", "dagger": "expertise", "strength_save": "proficiency"} = proficiency in history
                proficiencies[mod["subType"]] = mod["type"]
            } else if(mod["type"] === "advantage" || mod["type"] === "disadvantage") {
                // i.e. {"perception": "advantage", "insight": "disadvantage"}
                advantages[mod["subType"]] = mod["type"]
            // } else if(!(ignoreRace && key === 'race')) { // ignore race when needed
            } else {
                if(mod["type"] === "bonus") {
                    let fSubtypeName = mod["friendlySubtypeName"]
                    // Check if its a skill increase "Strength Score", "Dexterity Score" etc
                    let indexOfMatch = skills_long.indexOf(fSubtypeName)
                    if(indexOfMatch !== -1) {
                        bonuses[key][indexOfMatch] += mod["fixedValue"]
                    } else if(fSubtypeName === 'Armored Armor Class' || fSubtypeName === 'Armor Class') {
                        // Defense from Fighting Style - Defense: +1 to AC while wearing armor, Light Medium or Heavy
                        if(mod["componentId"] === 1789128) {
                            console.log(`AC Add When Armor Equipped: ${bonusAcWhenArmorEquipped} -> ${bonusAc + mod["value"]} from '${fSubtypeName}' ${mod["componentId"]} from key: ${key}`)
                            bonusAcWhenArmorEquipped += mod["value"]
                        }
                        // This was double applying items so i moved it down - keeping commented out just in case

                        // let appliedItem = data.inventory.filter(item => item.definition.id === mod["componentId"])[0]
                        // console.log(`AC Armor Class Applied items: ${bonusAc} -> ${bonusAc + mod["fixedValue"]} from '${appliedItem.definition.name}' ${mod["componentId"]} from key: ${key}`)
                        
                        // Get AC bonus from feats, class...
                        // bonusAc += mod["fixedValue"]
                        
                    } else if(fSubtypeName === 'Hit Points per Level') {
                        bonusHpPerLevel += mod["fixedValue"]
                    } else if(fSubtypeName === 'Initiative') {
                        // Extra bonus comes from things like "Alert"
                        if(mod.statId === null) {
                            if(mod.fixedValue) { 
                                console.log(`Initiative bonus mod: ${initExtraBonus} -> ${initExtraBonus + mod["fixedValue"]} from '${fSubtypeName}' ${mod["componentId"]} from key: ${key}`)
                                // This type of Alert has a fixed value
                                initExtraBonus += mod["fixedValue"]
                            } else if(mod.fixedValue === null && mod.bonusTypes.length > 0) {
                                // This type of Alert uses prof bonus so add it to the obj
                                // bonusType = 1 = add proficiency bonus to initiative
                                mod.bonusTypes.forEach(bonusType => {
                                    if(bonusType === 1) {
                                        let prof_bonus = levelData[total_lvl]?.profBonus || 0;
                                        console.log(`Initiative bonus mod prof_bonus: +${prof_bonus} from '${fSubtypeName}'`)
                                        initExtraBonus += prof_bonus || 0
                                    }
                                })
                            } else if(mod.componentId === 1789101) {
                                // This type of Alert uses prof bonus so add it to the obj
                                console.log(`Initiative proficiency bonus from Alert`)
                                proficiencies[mod["subType"]] = "proficiency"
                            }
                        } else {
                            // Bonuses to DEX - like if WIS mod is used for init/AC ontop of DEX
                            // This is the index of the stat, but dndb does not 0 index... so 1 is STR ... where it should be 0
                            bonusSkillInitMods.push(mod["statId"]-1);
                        }
                    }
                } else if(mod["type"] === "set") {
                    // Unarmored Armor Class but fixedValue is null
                    let fSubtypeName = mod["friendlySubtypeName"]
                    if(fSubtypeName === 'Unarmored Armor Class') {
                        // Dazzling footwork - Bard - no armor and no sheild, AC = 10 + DEX mod + CHA mod
                        // Draconic Resilience footwork - Sorceror
                        if(mod["componentId"] === 10292523 || mod["componentId"] === 10292944) {
                            newBaseACMods.push('DEX');
                            newBaseACMods.push('CHA');
                        // Unarmored Defense - Monk - no armor and no sheild, AC = 10 + DEX mod + WIS mod
                        } else if(mod["componentId"] === 10292257) {
                            newBaseACMods.push('DEX');
                            newBaseACMods.push('WIS');
                        // x2 Unarmored Defense - Barb - no armor and no sheild, AC = 10 + DEX mod + CON mod
                        } else if(mod["componentId"] === 10292151 || mod["componentId"] === 52) {
                            newBaseACMods.push('DEX');
                            newBaseACMods.push('CON');
                        }
                        
                        // Get AC bonus from feats, class...
                        console.log(`Bonus AC Unarmored Armor Class: ${bonusAc} -> ${bonusAc + mod["fixedValue"]} - componentId ${mod["componentId"]}`)
                        bonusAc += mod["fixedValue"]
                    } else if(mod['subType'].includes('-score')) {
                        console.log("Skill Override added:", key, mod['subType'])
                        // For When skill Overrides are found i.e. Set Constitution to 19
                        // Check later if skill is less then this
                        let skillIndex = mod['entityId']-1
                        bonuses.set[skillIndex] = mod['value']
                    } else if(fSubtypeName === 'AC Max Dex Armored Modifier') {
                        // Handle AC Max Dex Armored Modifier
                        maxDexArmorMod = mod['value']
                    }
                } 
            }
            //  else {
            //     console.log("2024 background found... Ignoring Old Racial Mods (if present)")
            // }
     })
    })


    let skills_json_array = [];
    for (let i = 0; i < 6; i++) {
        let skill = {
            "skill": skills_short[i],
            "base":  data["stats"][i]["value"],
            "race":       bonuses['race'][i],
            "class":      bonuses['class'][i],
            "background": bonuses['background'][i],
            "item":       bonuses['item'][i],
            "feat":       bonuses['feat'][i]
        };

        let userBonusValue = data["bonusStats"][i].value || 0
        let overRideValue = data["overrideStats"][i].value

        if(overRideValue) {
            skill["total score"] = overRideValue
        } else {
            skill["total score"] = 
                skill["base"] +
                skill["race"] +
                skill["class"] +
                skill["background"] +
                skill["item"] +
                skill["feat"] + 
                userBonusValue;
        }

        // Add the override if better then the previous total
        if(bonuses['set'][i] > skill['total score']) {
            console.log("Override skill from bonus.set @", i)
            skill['total score'] = bonuses.set[i]
        } 


        // either use the overRideValue if present, or get the total score + bonus values set by the user
        skill["modifier"] = Math.floor((skill["total score"] - 10) / 2);

        // console.log(
        //     "bonus:", userBonusValue,
        //     "override:", overRideValue,
        //     "total mod:", skill["modifier"],
        // )
        skills_json_array.push(skill);
    }
    
    // bonusHpPerLevel comes from races, mods, and other sources with the "Hit Points per Level" friendlySubtypeName
    let bonusHp = bonusHpPerLevel * total_lvl;
    let baseHp = data["baseHitPoints"];
    let maxHp = (skills_json_array[2]["modifier"] * total_lvl) + baseHp + bonusHp;

    if (data.overrideHitPoints) {
        maxHp = data.overrideHitPoints
    }

    // Bonushp is maxHP modifier 
    if (data.bonusHitPoints) {
        maxHp += data.bonusHitPoints
    }

    // =================
    // let nakedArmorClass = 10 + skills_json_array[1].modifier;
    let armorClass = bonusAc; // Start with AC from class/feat modifiers
    let shieldAcOnDexSaves = { shieldAc: 0, active: false, restrictions: [] };
    data.modifiers.feat.forEach(mod => {
        if (mod.type === "bonus") {
            if (mod.subType === "shield-ac-on-dex-saves") {
                shieldAcOnDexSaves.active = true;
                shieldAcOnDexSaves.restrictions = mod.restriction;
            }
        }
    });

    data.inventory.sort((a, b) => extractAc(b) - extractAc(a));

    let overRideArmor = false;
    if(data.characterValues) {
        data.characterValues.forEach(value => {
            if(value.typeId === 1) {
                armorClass = value.value
                console.log("AC Override Value true:", armorClass);
                overRideArmor = true
            }
        })
    }

    let shield = false;
    let armor = false;
    let inventory = [];
    const armorTypeKey = {
        0: "none",
        1: "light",
        2: "medium",
        3: "heavy",
    }
    let armorType = "none"
    let armorModAdded = false;

    data.inventory.forEach(item => {
        let itemDef = item.definition;
        let itemDictionary = {
            name: itemDef.name,
            attackType: itemDef.attackType,
            damage: itemDef.damage,
            damageType: itemDef.damageType,
            type: itemDef.type,
            description: itemDef.description,
            range: itemDef.range,
            longRange: itemDef.longRange,
            equipped: itemDef.equipped,
            quantity: itemDef.quantity,
            isAttuned: itemDef.isAttuned,
            filterType: itemDef.filterType,
            categoryId: itemDef.categoryId,
        };


        if (itemDef.properties) {
            let properties = itemDef.properties.map(prop => {
                let itemProp = {
                    name: prop.name,
                    description: prop.description
                };
                if (prop.notes) {
                    itemProp.notes = prop.notes;
                }
                return itemProp;
            });
            itemDictionary.properties = properties;
        }

        if(item.equipped) {
            if(!overRideArmor) {
                // If no current sheild and this item is a sheild then add AC 
                if (!shield && itemDef.baseArmorName === "Shield") {
                    console.log(`AC Shield: ${armorClass} -> ${armorClass + itemDef.armorClass} from '${itemDef.name}'`)
                    shield = true;
                    armorClass += itemDef.armorClass;

                    if(itemDef?.grantedModifiers.length > 0) {
                        itemDef.grantedModifiers.forEach(mod => {
                            let fSubtypeName = mod.friendlySubtypeName;
                            if(fSubtypeName === 'Armored Armor Class' || fSubtypeName === 'Armor Class') {
                                console.log(`AC Shield Granted Mod: ${armorClass} -> ${armorClass + mod.value} from '${itemDef.name}'`)
                                armorClass += mod.value;
                            }
                        })
                    }

                    // AC from sheild
                    if (shieldAcOnDexSaves.active) {
                        shieldAcOnDexSaves.shieldAc = itemDef.armorClass;
                    }
                } else if (!armor && itemDef.filterType === "Armor") {
                    armor = true;
                    // AC from armor
                    console.log(`AC Armor: ${armorClass} -> ${armorClass + itemDef.armorClass} from '${itemDef.name}'`)
                    armorClass += itemDef.armorClass;
                    armorType = armorTypeKey[itemDef.armorTypeId]
                    if(bonusAcWhenArmorEquipped > 0) {
                        console.log(`AC Armor Bonus: ${armorClass} -> ${armorClass + bonusAcWhenArmorEquipped} from 'Bonus AC when armor equipped'`)
                        armorClass += bonusAcWhenArmorEquipped
                    }
                }
            } 

            itemDef.grantedModifiers.forEach(mod => {
                // Armor class is handled above, so ignore it here
                if(!armorModAdded && mod.subType === 'armor-class' && !overRideArmor) {
                    if(itemDef.filterType === "Armor") {
                        armorModAdded = true;
                    }
                    console.log(`AC Item Mods: ${armorClass}-> ${armorClass + mod.fixedValue} from '${itemDef.name}'`)
                    armorClass += mod.fixedValue
                } else {
                    if(mod.type === 'bonus') {
                        if(mod.subType.includes('spell-save-dc')) {
                            if(mod.subType.includes(spellCastingInfo?.class?.toLowerCase())) {
                                console.log(`Spell Save DC (${spellCastingInfo?.class}): ${spellCastingInfo.spellSaveMod} -> ${spellCastingInfo.spellSaveMod + mod.fixedValue} from '${itemDictionary.name}'`)
                                spellCastingInfo.spellSaveMod += mod.fixedValue
                            }
                        } else if(mod.subType.includes('saving-throws')) {
                            console.log(`All Saves: +${mod.fixedValue} from '${itemDef.name}'`)

                            saveModifiers.forEach((saveMod, index) => {
                                saveModifiers[index] += mod.fixedValue
                            })
                        } 
                    }
                }
            })
        }

        
        
        inventory.push(itemDictionary);
    });

    // Unarmored Defense (Barbarian): Level 20 Barbarians can max out both Dexterity and Constitution at 30, granting a massive \(+10\) from Dex and \(+10\) from Con, for a base AC of 30.
    // Unarmored Defense (Monk): Monks can add their Dexterity and Wisdom modifiers to their AC. With a maximum of 30 in both stats, you can get a base AC of 30.
    // Light Armor: Grants an uncapped Dexterity bonus. The highest non-magical light armor is Studded Leather, which starts at AC 12. With a 30 Dexterity (\(+10\)), your total AC is 22.
    // Medium Armor: These armors limit how much of your agility you can use. Most medium armors cap your Dexterity bonus at \(+2\). However, if you take the Medium Armor Master feat, the cap is raised to \(+3\).
    // Heavy Armor: Heavy armor ignores Dexterity completely, meaning your Dex modifier adds \(+0\) to your AC.

    if(!overRideArmor) {
        // Base AC already set by armor above
        if(armor) { 
            // Only add dex mod to ac is not wearing heavy armor (heavy armor ignores dex mod)
            if(armorType === "light") { // light armor gets all dex mod
                console.log(`AC Light: ${armorClass} -> ${armorClass + skills_json_array[1].modifier} from DEX mod (+${skills_json_array[1].modifier})`)
                armorClass += skills_json_array[1].modifier
            } else if(armorType === "medium") { 
                // Medium armor gets max of +2 from dex mod (unless the Medium Armor Master feat is taken)
                let mediumAcMod = skills_json_array[1].modifier > maxDexArmorMod ? maxDexArmorMod : skills_json_array[1].modifier
                console.log(`AC Medium: ${armorClass} -> ${armorClass + mediumAcMod} from DEX mod (+${mediumAcMod}) (Capped at +2 unless from Armor Master feat)`)
                armorClass += mediumAcMod
            } 

        // Add the default 10 + DEX if no armor and other bonuses
        } else {
            console.log(`AC + DEX: ${armorClass} -> ${10 + skills_json_array[1].modifier} from STAT ${skills_json_array[1].skill}`)
            armorClass += 10 + skills_json_array[1].modifier
            // No armor or sheild of Unarmored Defense
            if(!shield) {
                newBaseACMods.forEach(newAcModName => {
                    // Dex already added in: skills_json_array[1].modifier
                    if(newAcModName !== "DEX") {
                        let baseAcModIndex = skills_short.indexOf(newAcModName)
                        console.log(`AC No Shield: ${armorClass} -> ${armorClass + skills_json_array[baseAcModIndex].modifier} from newAcModName ${newAcModName}`)
                        armorClass += skills_json_array[baseAcModIndex].modifier
                    }
                });
            }
        }
    }

    // Adds bonuses to initiative from other skills i.e. Init bonus equals your WIS mod
    if(bonusSkillInitMods.length > 0) {
        bonusSkillInitMods.forEach(skillIndex => {
            // add to dex so initative is later calculated - AC and other things are already calced above 
            skills_json_array[1]["total score"] += (skills_json_array[skillIndex]?.modifier*2 || 0)
        })
    }

    let speed = 30;
    data.customSpeeds.forEach(speedObj => {
        if(speedObj.movementId === 1 && speedObj.distance > speed) {
            speed = speedObj.distance
        }
    })

    return {maxHp, armorClass, speed, inventory, skills_json_array, proficiencies, initExtraBonus, advantages, spellCastingInfo, saveModifiers};
};

export default getSkillDetails;


